import { render, staticRenderFns } from "./reportPatriarchBoby.vue?vue&type=template&id=6e57c05f&scoped=true&"
import script from "./reportPatriarchBoby.vue?vue&type=script&lang=js&"
export * from "./reportPatriarchBoby.vue?vue&type=script&lang=js&"
import style0 from "./reportPatriarchBoby.vue?vue&type=style&index=0&id=6e57c05f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57c05f",
  null
  
)

component.options.__file = "reportPatriarchBoby.vue"
export default component.exports